
export default {
  name: 'BaseProfileStreamBroadcast',

  props: {
    stream: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      broadcast: null,
    }
  },

  async fetch() {
    if (this.stream?.id) {
      this.broadcast = await this.$axios.$get(
        `/advertisements/broadcasts/promo/stream/${this.stream.id}`
      )
    }
  },
  methods: {
    async updateProduct() {
      await this.$fetch()
    },
    async removeProduct() {
      await this.$fetch()
    },
  },
}
